const conversionMap = [
  ["ｳﾞｧ", "ﾊﾞ"],
  ["ｳﾞｨ", "ﾋﾞ"],
  ["ｳﾞｪ", "ﾍﾞ"],
  ["ｳﾞｫ", "ﾎﾞ"],
  ["ｳﾞｱ", "ﾊﾞ"],
  ["ｳﾞｲ", "ﾋﾞ"],
  ["ｳﾞｴ", "ﾍﾞ"],
  ["ｳﾞｵ", "ﾎﾞ"],
  ["ｳﾞ", "ﾌﾞ"],
  ["ｧ", "ｱ"],
  ["ｨ", "ｲ"],
  ["ｩ", "ｳ"],
  ["ｪ", "ｴ"],
  ["ｫ", "ｵ"],
  ["ｯ", "ﾂ"],
  ["ｬ", "ﾔ"],
  ["ｭ", "ﾕ"],
  ["ｮ", "ﾖ"],
  [" ", ""],
  ["･", ""],
  ["-", "ｰ"],
];

function conversionForCheck(str: string): string {
  let result = str;
  for (let [key, value] of conversionMap) {
    result = result.replaceAll(key, value);
  }

  return result;
}

/**
 * 業務チェック
 * @param name1 請求者名
 * @param name2 口座名義人名
 * @returns エラーメッセージ
 */
function businessCheck(name1: string, name2: string): "error" | "warning" | "" {
  let fullName1 = conversionForCheck(name1);
  let fullName2 = conversionForCheck(name2);
  let firstName1 = conversionForCheck(name1.split(" ")[1]);
  let firstName2 = conversionForCheck(name2.split(" ")[1]);

  if (fullName1 !== fullName2) {
    if (firstName1 === firstName2 || fullName2.indexOf(fullName1) === 0) {
      return "warning";
    }

    return "error";
  }

  return "";
}

export { conversionForCheck, businessCheck };
